export class PermissionsInterface {
  projectId: string;
  canView: boolean;
  canDelete: boolean;
  canEdit: boolean;
  canSimulate: boolean;
  canEditInitialInformation: boolean;
  readOnlyInitialChecklists: boolean;
  editOnlyInitialChecklists: boolean;
}

export class Permissions {
  projectId: string;
  canView: boolean;
  canDelete: boolean;
  canEdit: boolean;
  canSimulate: boolean;
  canEditInitialInformation: boolean;
  readOnlyInitialChecklists: boolean;
  editOnlyInitialChecklists: boolean;

  constructor(param: PermissionsInterface = {
    projectId: '',
    canView: false,
    canDelete: false,
    canEdit: false,
    canSimulate: false,
    canEditInitialInformation: false,
    readOnlyInitialChecklists: false,
    editOnlyInitialChecklists: false
  }) {
    if (param) {
      this.projectId = param.projectId;
      this.canView = param.canView;
      this.canDelete = param.canDelete;
      this.canEdit = param.canEdit;
      this.canSimulate = param.canSimulate;
      this.canEditInitialInformation = param.canEditInitialInformation;
      this.readOnlyInitialChecklists = param.readOnlyInitialChecklists ? param.readOnlyInitialChecklists : false;
      this.editOnlyInitialChecklists = param.editOnlyInitialChecklists ? param.editOnlyInitialChecklists : false;
    }
  }
}

export class UserInterface {
  id: string;
  name: string;
  adaPermissions: Permissions[];
  userrole?: string;
}

export class User {
  id: string;
  name: string;
  adaPermissions: Permissions[];
  userrole?: string;

  constructor(param: UserInterface = {
    id: '',
    name: '',
    adaPermissions: [],
  }) {
    if (param) {
      this.id = param.id;
      this.name = param.name;
      this.adaPermissions = param.adaPermissions;
    }
  }
}
